import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, PopoverController } from '@ionic/angular';
import { customValidators } from 'src/app/_helpers/customValidators';
import { globalHelper } from 'src/app/_helpers/global';
import { UserService } from 'src/app/_services';
import { ThisPlatform } from 'src/app/_services/platform.service';

@Component({
  selector: 'app-user-assignment-view-share',
  templateUrl: './user-assignment-view-share.component.html',
  styleUrls: ['./user-assignment-view-share.component.scss'],
})
export class UserAssignmentViewShareComponent implements OnInit {
  @Input()
  assignmentDetails;

  @Input()
  editAssignment: boolean;

  @Input() // Jest to input pozwalający na ograniczenie w wyborze daty
  timeOptions: {
    // Bez takiego ograniczenia można wysłać błędne zapytanie
    minDate: Date; // Input powinien być wykorzystany, wtedy gdy editAssinment jest ustalony na true,
    maxDate: Date; // w przeciwnym razie te dane i tak nie zostaną wykorzystane
  };

  constructor(
    public modalCtrl: ModalController,
    public userService: UserService,
    public p: ThisPlatform,
    private el: ElementRef,
    private popoverController: PopoverController,
    private translate: TranslateService
  ) {}

  form: FormGroup;
  startDate: Date = new Date();
  endDate: Date = new Date();

  validationError: boolean = false;
  disableUserSelect: boolean = true;

  ngOnInit() {
    this.initForm();

    if (this.editAssignment) {
      this.startDate = this.assignmentDetails.dateFrom;
      this.endDate = this.assignmentDetails.dateTo;
      this.form.patchValue({
        user: this.assignmentDetails.user,
      });
    } else {
      this.endDate =
        new Date().getHours() < 19
          ? new Date(new Date().setHours(19, 0, 0, 0))
          : new Date(new Date().setHours(new Date().getHours() + 1));
    }

    this.form.patchValue({
      dateFrom: this.startDate,
      dateTo: this.endDate,
    });

    this.userService.userBasic = null;
  }

  afterPickerClosed(date, startDate: string = 'start' || 'end') {
    if (startDate == 'start') {
      this.startDate = date;
      this.form.patchValue({
        dateFrom: date,
      });
    } else {
      this.endDate = date;
      this.form.patchValue({
        dateFrom: date,
      });
    }
  }

  initForm() {
    this.form = new FormGroup(
      {
        dateFrom: new FormControl(null, {
          updateOn: 'blur',
          validators: [Validators.required],
        }),
        dateTo: new FormControl(null, {
          updateOn: 'blur',
          validators: [Validators.required],
        }),
        user: new FormControl(this.userService.userBasic),
      },
      customValidators.dateValidator('dateFrom', 'dateTo')
    );
  }

  onShareUserAssignment() {
    if (this.disableUserSelect) {
      this.userService.userBasic = null;
    }

    this.form.patchValue({
      user: this.userService.userBasic,
      dateFrom: this.startDate,
      dateTo: this.endDate,
    });

    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }
    this.modalCtrl.dismiss(this.form.value);
  }

  onToggleSelectUser() {
    this.disableUserSelect = !this.disableUserSelect;
  }

  async onShowPopover(event: Event) {
    const popover = await globalHelper.Popover(
      this.popoverController,
      event,
      [],
      'user-assignment-view-share__popover',
      this.translate.instant('SPACE.I_POPOVER_TEXT')
    );
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }
}
